import Image from 'app/Components/Shared/Image/image';
import React from 'react'
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import './FuntoneButton.scss';
import Config from 'app/Config';

export const FuntoneButton = ({ text, variant = 'primary', onClick, disabled = false, icon }) => {
    const className = `funtone-button funtone-button--${variant}`;
    // console.log(icon);
    const buttonText = icon ? (
        <>
            <Image src={icon} alt="" className="funtone-button__icon" />
            {text}
        </>
    ) : text;
    return <BtnSubmit text={buttonText} className={className} onclick={onClick} disabled={disabled} />;
};

export default FuntoneButton;